<div class="dettaglio-campo-container">

  <h1 class="colorSearch" mat-dialog-title>
    {{this.isDettaglio && !this.isModifica ? "DETTAGLI CAMPO" : "MODIFICA CAMPO"}}
  </h1>

  <div mat-dialog-content [formGroup]="form">

    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class="searchbar inputText">
        <mat-label class="purp">Nome</mat-label>
        <input matInput [formControlName]="'nomeCampo'" [readonly]="(this.isDettaglio && !this.isModifica) || (this.predefinito && isModifica)" required>
        <mat-error *ngIf="this.form.controls.nomeCampo.errors">
          <mat-error *ngIf="this.form.controls.nomeCampo.errors.pattern">Nome non può contenere spazi o caratteri
            speciali</mat-error>
          <mat-error *ngIf="this.form.controls.nomeCampo.errors.required">Nome obbligatorio</mat-error>
          <mat-error *ngIf="this.form.controls.nomeCampo.errors.maxlength">Nome max 30 caratteri</mat-error>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class="searchbar inputText">
        <mat-label class="purp">Titolo</mat-label>
        <input matInput [formControlName]="'descrizione'" [readonly]="(this.isDettaglio && !this.isModifica) || (this.predefinito && isModifica)" required>
        <mat-error *ngIf="this.form.controls.descrizione.errors">
          <mat-error *ngIf="this.form.controls.descrizione.errors.maxlength">Titolo max 2000 caratteri</mat-error>
          <mat-error *ngIf="this.form.controls.descrizione.errors.required">Titolo obbligatorio</mat-error>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class="searchbar inputText">
        <mat-label class="purp">Obbligatorio</mat-label>
        <mat-select [formControlName]="'obbligatorio'" required>
          <mat-option value="S">Sì</mat-option>
          <mat-option value="N">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex-row">
      <mat-form-field appearance="fill" color='accent' class="searchbar inputText">
        <mat-label class="purp">Tipologia</mat-label>
        <mat-select [(value)]="selectedTipo" [formControlName]="'idTpCampoModulo'" required>
          <mat-option [value]=1>DATA</mat-option>
          <mat-option [value]=2>DESCRITTIVO</mat-option>
          <mat-option [value]=3>NUMERO</mat-option>
          <mat-option [value]=4>TENDINA</mat-option>
          <mat-option [value]=5>VALUTA</mat-option>
          <mat-option *ngIf="predefiniti" [value]=6>COORDINATE</mat-option>
          <mat-option [value]=7>MULTISELEZIONE</mat-option>
          <mat-option [value]=8>CODICE FISCALE</mat-option>
          <mat-option [value]=9>PARTITA IVA</mat-option>
          <mat-option [value]=10>INDIRIZZO EMAIL</mat-option>
        </mat-select>
        <mat-error *ngIf="this.form.controls.idTpCampoModulo.errors">
          <mat-error *ngIf="this.form.controls.idTpCampoModulo.errors.required">Tipologia obbligatorio</mat-error>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="flex-row" *ngIf="showListaEditabileValori" [hidden]="(this.isDettaglio && !this.isModifica) || (this.predefinito && isModifica)">
      <mat-form-field appearance="fill" color='accent' class="searchbar inputText">
        <mat-label>Aggiungi valore all'elenco valori</mat-label>
        <input matInput [formControlName]="'valore'" [readonly]="(this.isDettaglio && !this.isModifica) || (this.predefinito && isModifica)">
        <mat-error *ngIf="this.form.controls.valore.errors">
          <mat-error *ngIf="this.form.controls.valore.errors.pattern">Il valore non può contenere il carattere "|"</mat-error>
        </mat-error>
      </mat-form-field>
      <button mat-raised-button class="addButton" color='accent' (click)="addValue()"
        [disabled]="(this.isDettaglio && !this.isModifica) || (this.predefinito && isModifica)">+</button>
    </div>

    <div class="flex-row" *ngIf="showListaEditabileValori">
      <!-- <mat-form-field id='containerValori' appearance="fill" color='accent' class="searchbar"> -->
      <!-- <mat-label class="purp">Elenco valori</mat-label> -->

      <!-- <textarea id='elencoValori' matInput [formControlName]="'elencoValori'" cdkTextareaAutosize
        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5" hidden>
      </textarea> -->

      <mat-table [dataSource]="elencoValoriDataSource" matSort matSortDisabled class="elencoValoriTable">

        <ng-container matColumnDef="nomeValori">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="purp">Elenco valori</mat-header-cell>
          <mat-cell [attr.data-label]="'Elenco valori'" *matCellDef="let nameValore, let i = index">

            <mat-form-field appearance="fill" color='accent' class="tableForm" *ngIf="openToggle == i">
              <input matInput [value]="nameValore" #valorecambiato>
            </mat-form-field>


            <p class='descr-div' *ngIf="openToggle !== i">
              {{nameValore === ' '?"(Campo vuoto)":nameValore}}
            </p>


          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element; let i = index">
            <myp-toolbar *ngIf="(isDettaglio && !isModifica) || (!isDettaglio && !isModifica)"
              [toolbar]="openToggle == i?editToolbar:toolbar" role=toolbar [data]="element"
              (onToolbarEvent)="handleToolbarEvent($event,i)" class="pers-toolb-valori">
            </myp-toolbar>

          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="colonneTableValori"></mat-header-row>
        <mat-row *matRowDef="let row; columns: this.isDettaglio?colonneTableValorDescr:colonneTableValori"></mat-row>

      </mat-table>
      <!-- <span *ngFor="let val of listaValori">{{ val }}</span> -->
      <!-- <mat-select [formControlName]="'elencoValori'">
                <mat-option *ngFor="let valore of listaValori">{{ valore }}</mat-option>
            </mat-select> -->
      <!-- </mat-form-field> -->
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button mat-stroked-button color='accent' class='persBtn' mat-dialog-close>
      <p class='cont'>ANNULLA</p>
    </button>
    <button mat-raised-button color='accent' class='persBtn' (click)="saveCampo()"
      [disabled]="this.isDettaglio">
      <p class='cont'>SALVA CAMBIAMENTI</p>
    </button>
  </mat-dialog-actions>

</div>
